var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 1V8H27L20 1Z",
    fill: "#FF8F34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10V0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V31C0 31.2652 0.105357 31.5196 0.292893 31.7071C0.48043 31.8946 0.734784 32 1 32H27C27.2652 32 27.5196 31.8946 27.7071 31.7071C27.8946 31.5196 28 31.2652 28 31V10H18ZM6.5 8H13.5C13.6326 8 13.7598 8.05268 13.8536 8.14645C13.9473 8.24021 14 8.36739 14 8.5V9.5C14 9.63261 13.9473 9.75979 13.8536 9.85355C13.7598 9.94732 13.6326 10 13.5 10H6.5C6.36739 10 6.24021 9.94732 6.14645 9.85355C6.05268 9.75979 6 9.63261 6 9.5V8.5C6 8.36739 6.05268 8.24021 6.14645 8.14645C6.24021 8.05268 6.36739 8 6.5 8ZM21.5 24H6.5C6.36739 24 6.24021 23.9473 6.14645 23.8536C6.05268 23.7598 6 23.6326 6 23.5V22.5C6 22.3674 6.05268 22.2402 6.14645 22.1464C6.24021 22.0527 6.36739 22 6.5 22H21.5C21.6326 22 21.7598 22.0527 21.8536 22.1464C21.9473 22.2402 22 22.3674 22 22.5V23.5C22 23.6326 21.9473 23.7598 21.8536 23.8536C21.7598 23.9473 21.6326 24 21.5 24ZM21.5 17H6.5C6.36739 17 6.24021 16.9473 6.14645 16.8536C6.05268 16.7598 6 16.6326 6 16.5V15.5C6 15.3674 6.05268 15.2402 6.14645 15.1464C6.24021 15.0527 6.36739 15 6.5 15H21.5C21.6326 15 21.7598 15.0527 21.8536 15.1464C21.9473 15.2402 22 15.3674 22 15.5V16.5C22 16.6326 21.9473 16.7598 21.8536 16.8536C21.7598 16.9473 21.6326 17 21.5 17Z",
    fill: "#F5E0D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile);
export default __webpack_public_path__ + "static/media/icon-file.22f17b12139c05a58999d569bcc67b7f.svg";
export { ForwardRef as ReactComponent };